module.exports = __webpack_public_path__ + "img/COMBO SPIRAL LIME.07fdd6f.svg";